import CrudBaseService from "@/services/CrudBaseService";

export default class StudyService extends CrudBaseService {
  constructor() {
    super('insurance_pricing/study');
  }

  findPrices(data){
    return this.http.put(`${this._serviceName}/get_prices`,data);
  }
  
  findByLeadId(leadId){
    return this.http.get(`${this._serviceName}/lead/${leadId}`);
  }

  findByQuoteId(quoteId){
    return this.http.get(`${this._serviceName}/quote/${quoteId}`);
  }
  
  async save(data) {
    return await this.http.post(`${this._serviceName}/`,data);
  }
  
  async finish(data){
    return await this.http.post(`${this._serviceName}/lead-to-oportunity`,data);
  }

  getTemplates(quoteId) {
    return this.http.get(`${this._serviceName}/quotes/${quoteId}/templates`);
  }

  generatePresentation(quoteId, templateId) {
    return this.http.post(`${this._serviceName}/quotes/${quoteId}/presentations`, templateId);
  }
}
